<template>
	<div class="partners-store">
		<section class="partner-content container">
			<div class="togoback">
				<div class="content-brand w-100 mb-0">
					<GoToBackButton />
					<div class="content-brand-elements d-none d-lg-block">
						<router-link tag="a" :to="{ name: 'Home' }" class="content-brand-elements-links">
							Ínicio
						</router-link>
						<span> > </span>
						<router-link tag="a" :to="{ name: 'Partners' }" class="content-brand-elements-links">
							Beleza e Cuidados Pessoais
						</router-link>
						<span> > </span>
						<router-link tag="a" :to="{ name: 'PartnerStore' }" class="content-brand-elements-links">
							{{ partner.name }}
						</router-link>
					</div>
				</div>
				<SocialSharing :title="partner.name" :description="partner.short_description" class="d-lg-none"/>
			</div>
		</section>
		<BannerPartner :partner="partner" :total_comments="total_comments" />
		<HighlightedProducts :products="products"/>
		<Avaliation :partner="partner" :opinion="opinion" :total_comments="total_comments"/>
		<section class="partner-content container">
			<div class="togoback bottom">
				<div class="content-brand w-100 mb-0">
					<GoToBackButton />
				</div>
      </div>
    </section>
	</div>
</template>

<script>
import GoToBackButton from "@/components/goToBackButton/GoToBackButton.vue";
import SocialSharing from "@/components/socialSharing/SocialSharing.vue";
import BannerPartner from "@/components/partners/BannerPartner.vue";
import Avaliation from "@/components/avaliation/Index";
import HighlightedProducts from "@/components/highlighted/HighlightedProducts.vue";
import axios from 'axios';

export default {
  data() {
		return {
			partner: [],
			total_comments: 0,
			title: 'loja online',
			subtitle: 'Em destaque',
            products: [],
		}
  },
	components: {
    GoToBackButton,
		SocialSharing,
		BannerPartner,
		Avaliation,
		HighlightedProducts,
  },
  
  async mounted() {
        await this.getProducts();
    },
    methods: {
        async getProducts() {
        axios.post('api/v1/ecommerce/producthighlighted', { partner_id: 28 })
            .then(resp => {
                if (resp && resp.data) {
                    this.products = resp.data;
                }
            })
            .catch(error => {
                console.log(error);
            });
        },
    },
}
</script>

<style lang="scss" scoped>
.partner-content{
	margin-bottom: 3rem;
	@media screen and (max-width: 768px){
		padding-bottom: 0;
		margin-bottom: 0;
	}
}
.partners-store {
	margin-top: 170px;
	padding-top: 30px;
	@media screen and (max-width: 991px) {
		margin-top: 62px;
		padding-top: 0px;
		padding-bottom: 50px;
		max-width: 100%;
	}
}
.line-clamp{
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.togoback{
    padding-top:2rem;
    margin-bottom: 3rem;
    display: flex;
    flex-direction: row;
    &-btn{
        display: flex;
        background-color: #FFFFFF;
        width: 114px;
        height: 47px;
        margin-right: 1rem;
        border: 1px solid var( --green-medium);
        border-radius: 10px;
        justify-content: center;
        align-items: center;
        &:hover, &:focus{
            transition: all 0.5s ease;
            filter: drop-shadow(0 0 10px var( --green-medium));
        }
        @media screen and (max-width: 768px){
            width: 100px;
            height: 40px;
        }
        @media screen and (max-width: 576px){
            width: 70px;
            height: 35px;
            margin-right: 0.5rem;
        }
        a{
            font-family: 'Font Regular', sans-serif;
            font-size:1.375rem;
            color: var( --green-medium);
            @media screen and (max-width: 768px){
                font-size: 1.125rem;
            }
            @media screen and (max-width: 576px){
                font-size: 0.8rem;
            }
        }
    }
    &-path{
        padding: 0;
        display: flex;
        align-items: center;
        p{
            color: #112D23;
            font-family: 'Font Semibold', sans-serif;
            font-size: 1.563rem;
            margin: 0;
            @media screen and (max-width: 768px){
                font-size: 1rem;
            }
            @media screen and (max-width: 576px){
                font-size: 0.8rem;
                align-items: flex-start;
                text-align: left;
            }
            @media screen and (max-width: 400px){
                font-size: 0.7rem;
            }
        };
        
    }
}
.content-banner{
    height: 672px;
    padding: 0;
    background-color: #F2F2F2;
    @media screen and (max-width: 992px){
        height: auto;
    }
    &-img{
        height: 450px;
        @media screen and (max-width: 992px){
            height: 300px;
        }
        @media screen and (max-width: 768px){
            height: auto;
        }
        img{
            width: 100%;
            height: 100%;
        }
    }
    &-logo{
        margin-top:-7rem;
        position: relative;
        display: flex;
        justify-content: flex-end;
        padding-right: 2rem; 
        @media screen and (max-width: 992px){
            margin-top: -5rem;
            padding-right: 1rem;
        }
        @media screen and (max-width: 768px){
            margin-top: -2.5rem;
        }

        img{
            width:200px;
            height: 200px;
            @media screen and (max-width: 992px){
                width:150px;
                height: 150px;
            }
            @media screen and (max-width: 768px){
                width:100px;
                height: 100px;
            }
            @media screen and (max-width: 576px){
                width:75px;
                height: 75px;
            }
        }    
    }
    &-text{
        margin-top: -5rem;
        padding: 2rem;
        @media screen and (max-width: 992px){
            margin-top: -3rem;
        }
        @media screen and (max-width: 768px){
            margin-top: -2rem;
            padding: 1.5rem;
        }

        &-int{
            width: 807px;
            text-align: left;
            @media screen and (max-width: 992px){
                width: 80%;
            }
            @media screen and (max-width: 576px){
                width: 70%;
            }

            h2 {
                font-family: 'Font Bold', sans-serif;
                font-size: 2.125rem;
                color: #112D23;
                margin-bottom: 2rem;
                @media screen and (max-width: 992px){
                    font-size: 1.5rem;
                }
                @media screen and (max-width: 768px){
                    font-size: 1.25rem;
                }
                @media screen and (max-width: 576px){
                    font-size: 1rem;
                    margin-bottom: 1rem;
                }
            }
            &-localization{
                display: flex;
                flex-direction: row;
                align-items: center;
                p{
                    margin: 0;
                    font-family: 'Font Regular', sans-serif;
                    font-size: 1.5rem;
                    color: #112D23;
                    @media screen and (max-width: 992px){
                        font-size: 1.2rem;
                    }
                    @media screen and (max-width: 768px){
                        font-size: 1rem;
                    }
                    @media screen and (max-width: 576px){
                        font-size: 0.8rem;
                    }

                }
                svg{
                    margin-right: 1rem;
                    @media screen and (max-width: 768px){
                        width: 15px;
                    }
                }
            }
        
        }
        
    }
}
.content-description{
    margin-top: 4rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    @media screen and (max-width: 992px){
        margin-top: 2rem;
    }

    p{
        font-size: 1.5rem;
        font-family: 'Font Regular', sans-serif;
        color: #555555;
        text-align: justify;
        @media screen and (max-width: 992px){
            font-size: 1.2rem;
        }
        @media screen and (max-width: 768px){
            font-size: 1rem;
        }
    }
    a{
        text-decoration:1px solid underline!important;
        color: var( --green-medium);
        font-family: 'Font Bold', sans-serif;
        font-size: 1.875rem;
        @media screen and (max-width: 992px){
            font-size: 1.5rem;
        }
        @media screen and (max-width: 768px){
            font-size: 1.25rem;
        }
        @media screen and (max-width: 576px){
            font-size: 1rem;
        }

    }
}
.content-highlighted{
    @media screen and (max-width: 992px){
        width: 100%;
    }
}
</style>